import httpManager from "@/app/shared/utils/httpManager";
import {
  ReportTypes,
  CustomerSupportReportTypes,
  CustomerSupportReportTypesNames,
} from "@/app/reports/utils/enums";

export async function fetchTimeSectionType({ filters } = {}) {
  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `queue=${filters.queue}&`;
  query += `start_date=${filters.startDate}&`;
  query += `end_date=${filters.endDate}`;

  const type = CustomerSupportReportTypesNames[CustomerSupportReportTypes.TimeSection];

  const url = `/reports/${ReportTypes.CustomerSupport}/?type=${type}&${query}`;

  const response = await httpManager.get(url);
  return response?.data;
}
